import { FC, ReactNode } from 'react';
import stylex from '@stylexjs/stylex';
import { ExclamationCircleIcon } from '@shared/assets/icons';
import { styles } from '../MainGuestTab/styles';

export interface OptionGroupGroup {
  instanceId: string;
  title?: string;
  isTitleVisible?: boolean;
}

export interface OptionGroupProps {
  group: OptionGroupGroup;
  error?: string;
  errorWrapperStyle?: typeof styles.radioGroupError;
  children: ReactNode;
}

export const OptionGroup: FC<OptionGroupProps> = ({ group, error, errorWrapperStyle, children }) => {
  const showTitle = group.isTitleVisible ?? true;
  const hasVisibleTitle = showTitle && group.title != null && group.title !== '';

  return (
    <div {...stylex.props(styles.sectionDeliveryMethod, error && errorWrapperStyle ? errorWrapperStyle : undefined)}>
      {hasVisibleTitle && <h3 {...stylex.props(styles.sectionTitle)}>{group.title}</h3>}
      <div {...stylex.props(styles.deliveryMethodOptions)}>{children}</div>
      {error && (
        <div {...stylex.props(styles.radioErrorContainer)}>
          <ExclamationCircleIcon />
          <span {...stylex.props(styles.radioErrorText)}>{error}</span>
        </div>
      )}
    </div>
  );
};
